import {
  Marker,
  MarkerProps,
  GoogleMapProps,
  WithScriptjsProps,
  WithGoogleMapProps,
} from 'react-google-maps';
import styled from 'styled-components';
import { GetMapDetailResponse } from '../../../types';
type SectionProps = GoogleMapProps & {};

export type MarkerStyledProps = MarkerProps & {
  dataItem?: ItemMarket;
  listStatus?: GetMapDetailResponse;
};
export type MapProps = GoogleMapProps &
  WithGoogleMapProps &
  WithScriptjsProps & {
    listMarket?: ItemMarket[];
    listStatus?: GetMapDetailResponse[] | [];
  };
export type ItemMarket = {
  site_id: number;
  building_id: number;
  building_code: string;
  site_lat: number;
  site_lng: number;
  status_active: number;
  number_of_workers: number;
};
export type MapComponentProps = GoogleMapProps & {
  listMarket?: ItemMarket[];
  listStatus?: GetMapDetailResponse[] | [];
};
export const MarkerStyled = styled(Marker)<MarkerStyledProps>`
  display: none;
`;

export default styled.div<SectionProps>`
  width: 100%;
  .label-custom {
    height: 33px;
  }
  .container-info-windown {
    .status {
      height: 20px;
      width: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      margin-bottom: 8px;
      color: var(--white);
      &.working {
        background-color: var(--green);
      }
      &.rest {
        background-color: var(--red);
      }
      &.not_start {
        background-color: var(--gray);
      }
    }
    .title {
      color: var(--black);
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 600;
    }
    .text-content {
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
      color: var(--black);
    }
    .box_button {
      margin-top: 15px;
    }
  }
`;
